var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#848383",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.332 5.749H1.102v-2.3c0-.317.247-.575.552-.575h1.653v1.15c0 .318.247.575.552.575a.563.563 0 0 0 .55-.575v-1.15h6.616v1.15c0 .318.246.575.55.575a.563.563 0 0 0 .552-.575v-1.15h1.654c.304 0 .551.258.551.575v2.3zm0 9.89a.563.563 0 0 1-.551.575H1.654a.563.563 0 0 1-.552-.575V6.9h13.23v8.74zm-.551-13.914h-1.654V.575A.563.563 0 0 0 11.576 0a.563.563 0 0 0-.551.575v1.15H4.41V.575A.563.563 0 0 0 3.859 0a.563.563 0 0 0-.552.575v1.15H1.654C.74 1.725 0 2.497 0 3.449v12.19c0 .953.74 1.725 1.654 1.725H13.78c.913 0 1.654-.772 1.654-1.725V3.45c0-.952-.74-1.724-1.654-1.724z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.622 8.773a.584.584 0 0 0-.812 0L6.55 13.036 4.625 11.11a.584.584 0 0 0-.827.827l2.338 2.337a.584.584 0 0 0 .826 0L11.636 9.6a.585.585 0 0 0-.014-.827z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.e9232180d0d3a5a226b95bbbc31f6ab5.svg";
export { ForwardRef as ReactComponent };